import { Observable } from 'rxjs/Observable';
import { CccSocketProvider } from './../../providers/ccc-socket/ccc-socket';
import { CoinsProvider } from './../../providers/coins/coins';
import { ViewController, ModalController, AlertController, ToastController } from 'ionic-angular';
import { Component } from '@angular/core';
import { NavController } from '../../../node_modules/ionic-angular/navigation/nav-controller';
import { UserProvider } from '../../providers/user/user';
import { Stream, newStream } from '../../models/Stream';
import { StreamProvider } from '../../providers/stream/stream';

@Component({
    selector: 'add-stream',
    templateUrl: 'add-stream.html'
})
export class AddStreamComponent {
    stream: Stream;
    editMode: boolean = false;
    newStream: boolean = false;

    isAdmin: Observable<boolean>;
    constructor(
        public viewCtrl: ViewController,
        public navCtrl: NavController,
        public modalCtrl: ModalController,
        public coinCtrl: CoinsProvider,
        public socket: CccSocketProvider,
        public alertCtrl: AlertController,
        public toastCtrl: ToastController,
        public streamsCtrl: StreamProvider,
        public userCtrl: UserProvider
    ) {

        this.isAdmin = this.userCtrl.isAdmin();

        //Set up editor if param passed in
        let stream: Stream = this.viewCtrl.getNavParams().get('stream');

        console.log(stream);
        if (stream) {
            this.stream = stream;
        }else{
            this.newStream = true;
            this.stream = newStream();
        }
    }

    removeStream() {
        const alert = this.alertCtrl.create({
            title: `Delete Stream`,
            subTitle: `Are you sure you want to delete this Stream? You really shouldn't do this unless you've made a mistake.`,
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel'
                },
                {
                    text: 'Yes',
                    handler: data => {
                        this.streamsCtrl.removeStream(this.stream).then(val => {
                            this.toastCtrl.create({ message: 'Stream Deleted', duration: 2000 }).present();
                            this.dismiss();
                        });
                    }
                }
            ]
        })
        alert.present();
    }
    saveStream() {
        const alert = this.alertCtrl.create({
            title: `Save Stream`,
            subTitle: `Are you sure you want to save this stream?`,
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel'
                },
                {
                    text: 'Yes',
                    handler: data => {
                        this.streamsCtrl.editStream(this.stream).then(val => {
                            this.toastCtrl.create({ message: 'Stream Saved', duration: 2000 }).present();
                            this.dismiss();
                        });
                    }
                }
            ]
        })
        alert.present();
    }

    publishStream() {

        const alert = this.alertCtrl.create({
            title: `Publish Stream`,
            subTitle: `Are you sure you are ready to publish this stream? Might wanna double check.`,
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel'
                },
                {
                    text: 'Yes',
                    handler: data => {
                        this.stream.timestamp = (new Date()).getTime();
                        this.streamsCtrl.addStream(this.stream).then(val => {
                            this.toastCtrl.create({ message: 'Stream Published', duration: 2000 }).present();
                        });
                        this.dismiss();
                    }
                }
            ]
        })
        alert.present();
    }

    getGainClass(gain: number): string {
        if (gain > 0) {
            return 'target';
        } else if (gain < 0) {
            return 'stop';
        } else {
            return '';
        }
    }

    dismiss() {
        this.viewCtrl.dismiss();
    }

    onLoad(e){
        console.log(e);
    }
    onError(e){
        console.log(e);
    }
}



// WEBPACK FOOTER //
// ./src/components/add-stream/add-stream.ts